import React, { FC } from 'react';

import NavBar from '@/components/nav-bar/NavBar';
import TopBar from '@/components/top-bar/TopBar';
import { SWrapper } from '@/components/message-center/styles/MessageCenter.styled';
import SBody from '@/components/shared/styles/Body.styled';

interface ILayoutProps {
  children: React.ReactNode;
  hasNoWrapper?: boolean;
  hasMinWidth?: boolean;
  isTopBarUsable?: boolean;
  isSysPrinDocTypeHidden?: boolean;
  displayTopBar?: boolean;
  expanded?: boolean;
}

const Layout: FC<ILayoutProps> = ({
  children,
  hasNoWrapper = false,
  hasMinWidth = false,
  isTopBarUsable = true,
  isSysPrinDocTypeHidden = false,
  displayTopBar = true,
  expanded = false,
}) => {
  const renderContent = () => {
    return hasNoWrapper ? (
      children
    ) : (
      <SWrapper expanded={expanded} className="divSWrapper">
        {children}
      </SWrapper>
    );
  };

  return (
    <>
      <NavBar />
      <SBody className={`divSBody ${hasMinWidth ? 'has-min-width' : ''}`}>
        {displayTopBar && <TopBar isSysPrinDocTypeHidden={isSysPrinDocTypeHidden} isTopBarUsable={isTopBarUsable} />}
        {renderContent()}
      </SBody>
    </>
  );
};

export default Layout;
